export default function List({ children }) {
  return <ul className="divide-y rounded-lg divide-slate-100">{children}</ul>;
}
